/*
 * EDITING THIS?
 * Please clean up UNSAFE_componentWillReceiveProps!
 * See: https://github.com/Tettra/tettra-wiki/issues/6002
 */

import React from 'react';
import { navigate } from '@reach/router';
import Tippy from '@tippyjs/react';

import {
    getPageUrlFromSlug,
    getApiFolderUrl,
    getCreateDraftUrlFromFolderId,
    getSubcategoryUrl,
    getSuggestionUrl,
    getExternalResourceUrl,
    getQuestionUrl,
    getDocumentUrl,
} from '../../utilities/urlHelper';

import {
    isPage,
    isSuggestion,
    isExternal,
    isSubcategory,
    isQuestion,
    isDocument,
} from '../../utilities/categoryUtilities';

import { canCreatePage, canCreateQuestion, canEditCategory } from '../../utilities/permissionsUtilities';

import MoveSubcategoryWrapper from '../move/MoveSubcategoryWrapper';
import CreateSubcategoryWrapper from '../create/CreateSubcategoryWrapper';
import CreateOrEditCategoryWrapper from '../create/CreateOrEditCategoryWrapper';
import { ICON } from '../../utilities/CONSTANTS';
import { getDocumentIcon } from '../../utilities/imageUtilities';

class PageItem extends React.Component {

    elementRef = React.createRef();

    componentDidMount() {
        const { page: { id: pageId } } = this.props;
        if (pageId === window.pageId && this.elementRef.current) {
            this.elementRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    clickPage = (e) => {
        const { page: { id, title, slug } } = this.props;
        const isActivePage = id === window.pageId;
        if (!e.metaKey && window.isApp && !isActivePage) {
            e.preventDefault();
            e.stopPropagation();
            const pageUrl = getPageUrlFromSlug(slug);
            const context = 'sidebar';

            return navigate(pageUrl, { state: { title, context } });
        }
    };

    render() {
        const { page } = this.props;
        const isActivePage = page.id === window.pageId;
        const className = isActivePage ? 'left-nav__selected' : '';
        const pageHref = isActivePage ? '#page-top' : getPageUrlFromSlug(page.slug);

        const nestingLevel = this.props.level ?? 0;

        return (
            <div ref={this.elementRef}>
                <div className={`left-nav__item left-nav__page ${className}`} style={getListItemIndent(nestingLevel)}>
                    <img className="left-nav__page-icon" height="18" width="18" src="/img/icons/file-icon-page.png" alt="" />
                    <a
                        href={pageHref}
                        className="left-nav__text"
                        onClick={this.clickPage}
                        dangerouslySetInnerHTML={{
                            __html: page.title,
                        }}
                    />
                    {
                        !!page.is_pinned
                        && (
                            <Tippy content="Pinned page" placement="top">
                                <img
                                    src="/img/icons/pin.png"
                                    className="pin-icon ml1"
                                    height="12"
                                    alt="Pinned page"
                                    aria-hidden="true"
                                />
                            </Tippy>
                        )
                    }
                </div>
            </div>
        );
    }
}

class SuggestionItem extends React.Component {

    elementRef = React.createRef();

    componentDidMount() {
        const { suggestion } = this.props;

        if (suggestion.id === window.suggestionId && this.elementRef.current) {
            this.elementRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    clickSuggestion = (e) => {
        const { suggestion } = this.props;
        const isActiveSuggestion = suggestion.id === window.suggestionId;
    };

    render() {
        const { suggestion } = this.props;
        const isActiveSuggestion = suggestion.id === window.suggestionId;
        const className = isActiveSuggestion ? 'left-nav__selected' : '';
        const suggestionUrl = isActiveSuggestion ? '#' : getSuggestionUrl(suggestion.id);
        const nestingLevel = this.props.level ?? 0;

        return (
            <div className={`${className}`} ref={this.elementRef}>
                <a href={suggestionUrl} className="left-nav__item left-nav__suggestion" style={getListItemIndent(nestingLevel)} onClick={this.clickSuggestion}>
                    <img className="left-nav__page-icon" height="18" width="18" src="/img/icons/file-icon-page-request.png" alt="page icon" />
                    <span className="left-nav__text">
                        {suggestion.title}
                    </span>
                    {
                        !!suggestion.is_pinned
                        && (
                            <Tippy content="Pinned suggestion" placement="top">
                                <img
                                    src="/img/icons/pin.png"
                                    className="pin-icon ml1"
                                    height="12"
                                    alt="Pinned suggestion"
                                    aria-hidden="true"
                                />
                            </Tippy>
                        )
                    }
                </a>
            </div>
        );
    }
}

class ExternalResourceItem extends React.Component {

    elementRef = React.createRef();

    componentDidMount() {
        const { externalResource } = this.props;

        if (externalResource.id === window.externalResourceId && this.elementRef.current) {
            this.elementRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    render() {
        const { externalResource } = this.props;
        const isActiveResource = externalResource.id === window.externalResourceId;
        const className = isActiveResource ? 'left-nav__selected' : '';
        const resourceUrl = isActiveResource ? '#' : getExternalResourceUrl(externalResource.id);
        const title = externalResource.title
            ? externalResource.title
            : externalResource.slug;

        const iconUrl = externalResource.icon ? externalResource.icon : '/img/icons/file-icon-link.png';
        const nestingLevel = this.props.level ?? 0;

        return (
            <div className={`${className}`} ref={this.elementRef}>
                <a href={externalResource.slug} className="left-nav__item left-nav__external-doc" style={getListItemIndent(nestingLevel)} target="_blank" rel="noreferrer">
                    <img className="left-nav__page-icon" height="18" width="18" src={iconUrl} alt="external resource icon" aria-hidden="true" />
                    <span className="left-nav__text" title={title}>
                        {title}
                    </span>
                    {
                        !!externalResource.is_pinned
                        && (
                            <Tippy content="Pinned link" placement="top">
                                <img
                                    src="/img/icons/pin.png"
                                    className="pin-icon ml1"
                                    height="12"
                                    alt="Pinned link"
                                    aria-hidden="true"
                                />
                            </Tippy>
                        )
                    }
                </a>
            </div>
        );
    }
}

class DocumentItem extends React.Component {

    elementRef = React.createRef();

    componentDidMount() {
        const { document } = this.props;

        if (document.id === window.documentId && this.elementRef.current) {
            this.elementRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    render() {
        const { document } = this.props;
        const isActiveResource = document.id === window.documentId;
        const className = isActiveResource ? 'left-nav__selected' : '';
        const title = document.title
            ? document.title
            : document.slug;

        const nestingLevel = this.props.level ?? 0;

        const iconUrl = getDocumentIcon(document);

        return (
            <div className={`${className}`} ref={this.elementRef}>
                <a href={getDocumentUrl(document.id)} className="left-nav__item left-nav__external-doc" style={getListItemIndent(nestingLevel)} rel="noreferrer">
                    <img className="left-nav__page-icon" height="18" width="18" src={iconUrl} alt="external resource icon" aria-hidden="true" />
                    <span className="left-nav__text" title={title}>
                        {title}
                    </span>
                    {
                        !!document.is_pinned
                        && (
                            <Tippy content="Pinned document" placement="top">
                                <img
                                    src="/img/icons/pin.png"
                                    className="pin-icon ml1"
                                    height="12"
                                    alt="Pinned document"
                                    aria-hidden="true"
                                />
                            </Tippy>
                        )
                    }
                </a>
            </div>
        );
    }
}

class QuestionItem extends React.Component {
    elementRef = React.createRef();

    componentDidMount() {
        const { question } = this.props;

        if (question.id === window.questionId && this.elementRef.current) {
            this.elementRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    render() {
        const { question } = this.props;
        const isActiveResource = question.id === window.questionId;
        const className = isActiveResource ? 'left-nav__selected' : '';
        const questionUrl = isActiveResource ? '#' : getQuestionUrl(question.id);
        const { title } = question;

        const nestingLevel = this.props.level ?? 0;
        const iconUrl = question.is_answered ? ICON.QUESTION_ANSWERED : ICON.QUESTION;

        return (
            <div className={`${className}`} ref={this.elementRef}>
                <a href={questionUrl} className="left-nav__item left-nav__external-doc" style={getListItemIndent(nestingLevel)}>
                    <img className="left-nav__page-icon" height="18" width="18" src={iconUrl} alt="external resource icon" aria-hidden="true" />
                    <span className="left-nav__text" title={title}>
                        {title}
                    </span>
                    {
                        !!question.is_pinned
                        && (
                            <Tippy content="Pinned question" placement="top">
                                <img
                                    src="/img/icons/pin.png"
                                    className="pin-icon ml1"
                                    height="12"
                                    alt="Pinned question"
                                    aria-hidden="true"
                                />
                            </Tippy>
                        )
                    }
                </a>
            </div>
        );
    }
}

const getActiveFolderId = () => {
    if (window.folderId) {
        return window.folderId;
    } if (window._tettraDraft) {
        return window._tettraDraft.folder_id;
    }
    return null;
};

const getActiveBreadcrumbIds = () => {
    if (window.breadcrumbs) {
        return window.breadcrumbs;
    }

    return [];
};

const getActiveCategoryId = () => {
    if (window.categoryId) {
        return window.categoryId;
    } if (window._tettraDraft) {
        return window._tettraDraft.category_id;
    }
    return null;
};

const onResourceShowView = () => Boolean(window.pageId || window.suggestionId || window.documentId || window.questionId || window.externalResourceId);

class SubcategoryItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = this.getState(props);
    }

    /*
     * EDITING THIS?
     * Please clean up UNSAFE_componentWillReceiveProps!
     * See: https://github.com/Tettra/tettra-wiki/issues/6002
     */
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { folder, folderItems, open: wasOpen } = this.state;
        const activeFolderId = getActiveFolderId();
        const breadcrumbIds = getActiveBreadcrumbIds();
        const open = wasOpen
            || ((window.pageId || window.suggestionId || window.draftId)
                && (activeFolderId === folder.id || breadcrumbIds.includes(folder.id)));

        if (open && !folderItems) {
            $.get(getApiFolderUrl(folder.category_id, folder.id)).then(({ folderItems }) => this.setState({ folderItems }));
        }

        return this.setState({ open });
    }

    getState = (props) => {
        const { folder } = props;
        const folderItems = null;

        const activeFolderId = getActiveFolderId();
        const breadcrumbIds = getActiveBreadcrumbIds();
        const activeCategoryId = getActiveCategoryId();

        const categoryOpen = activeCategoryId === folder.category_id;
        const folderOpen = activeFolderId === folder.id || breadcrumbIds.includes(folder.id);
        const open = categoryOpen && folderOpen;

        if (open) {
            $.get(getApiFolderUrl(folder.category_id, folder.id)).then(({ folderItems }) => this.setState({ folderItems }));
        }

        return { folder, open, folderItems };
    };

    toggleFolder = () => {
        let { open, folderItems, folder } = this.state;

        if (!open && folderItems == null) {
            $.get(getApiFolderUrl(folder.category_id, folder.id)).then(({ folderItems }) => this.setState({ folderItems }));
        }

        open = !open;

        return this.setState({ open });
    };

    getFolderItems = () => {
        const { folder, folderItems } = this.state;
        const nestingLevel = this.props.level ?? 0;

        // remove falsey values caused by iffy data
        let folderItemsItems = folderItems.filter(Boolean);

        const items = folderItemsItems.map((item, index) => {
            if (isPage(item)) {
                return <PageItem page={item} level={nestingLevel + 1} key={item.id + item.type} />;
            } if (isSuggestion(item)) {
                return <SuggestionItem suggestion={item} level={nestingLevel + 1} key={item.id + item.type} />;
            } if (isExternal(item)) {
                return <ExternalResourceItem externalResource={item} level={nestingLevel + 1} key={item.id + item.type} />;
            } if (isSubcategory(item)) {
                return <SubcategoryItem folder={item} level={nestingLevel + 1} key={item.id + item.type} />;
            } if (isQuestion(item)) {
                return <QuestionItem question={item} level={nestingLevel + 1} key={item.id + item.type} />;
            } if (isDocument(item)) {
                return <DocumentItem document={item} level={nestingLevel + 1} key={item.id + item.type} />;
            }
        });

        return (
            <div>
                {items}
            </div>
        );
    };

    render() {
        const { open, folder, folderItems } = this.state;
        const nestingLevel = this.props.level ?? 0;

        const isActiveFolder = (getActiveFolderId() === folder.id) && !onResourceShowView();

        const folderItemClass = isActiveFolder ? 'left-nav__item left-nav__category left-nav__selected' : 'left-nav__item left-nav__category';
        const hasCategoryActions = canCreatePage() || canEditCategory();

        return (
            <div className="left-nav__folder-container">
                <div className={folderItemClass} style={getExpandableItemIndent(nestingLevel)}>
                    <span className="expand-caret" onMouseDown={this.toggleFolder}>
                        {(open ? '⌄' : '›')}
                    </span>
                    <img className="left-nav__icon" height="22" width="22" src={folder.icon} style={{ backgroundColor: `#${folder.color}` }} alt="folder icon" />
                    <a className="left-nav__text" href={getSubcategoryUrl(folder.id)} title={folder.title}>
                        {folder.title}
                    </a>
                    {
                        !!folder.is_pinned
                        && (
                            <Tippy content="Pinned subcategory" placement="top">
                                <img
                                    src="/img/icons/pin.png"
                                    className="pin-icon ml1"
                                    height="12"
                                    alt="Pinned subcategory"
                                    aria-hidden="true"
                                />
                            </Tippy>
                        )
                    }
                    <div className="dropdown dropdown-right-aligned flex-none">
                        {hasCategoryActions
                            && (
                                <button className="left-nav__menu dropdown-link" type="button">
                                    <img className="button-icon" height="16" width="4" src="/img/icons/dropdown-elipsis.svg" alt="dropdown menu" />
                                </button>
                            )}
                        <div className="dropdown-overlay" style={{ display: 'none' }} />
                        <div className="dropdown-content no-select" style={{ display: 'none' }}>
                            {canEditCategory()
                            && (
                                <CreateOrEditCategoryWrapper folder_id={folder.id} category_id={folder.category_id}>
                                    <span className="dropdown-option link">Edit</span>
                                </CreateOrEditCategoryWrapper>
                            )}
                            {canEditCategory() && <MoveSubcategoryWrapper subcategory={folder} />}
                            {canCreateQuestion()
                                && (
                                    <span className="link dropdown-option category-new-question-link" data-category-id={folder.category_id} data-folder-id={folder.id}>
                                   New question
                                    </span>
                                )}
                            {canCreatePage() && <a className="dropdown-option" href={getCreateDraftUrlFromFolderId(folder.id)}>New page</a>}
                            {canEditCategory()
                                    && (
                                        <CreateSubcategoryWrapper
                                            categoryId={folder.category_id}
                                            parentFolderId={folder.id}
                                            parentName={folder.title}
                                            isSidebar
                                        />
                                    )}
                            <a className="dropdown-option do-cancel">Cancel</a>
                        </div>
                    </div>
                </div>
                <div className="folder-pages">
                    {open && (folderItems == null)
                        && <div className="left-nav__loading loading" style={getLoadingTextIndent(nestingLevel)}>Loading subcategory</div>}
                    {open && folderItems && (folderItems.length > 0
                        ? this.getFolderItems()
                        : <div className="left-nav__loading" style={getLoadingTextIndent(nestingLevel)}>No items</div>)}
                </div>
            </div>
        );
    }
}

const getExpandableItemIndent = nestingLevel => ({ marginLeft: `${16 + nestingLevel * 13}px` });
const getListItemIndent = nestingLevel => ({ marginLeft: `${24 + nestingLevel * 13}px` });
const getLoadingTextIndent = nestingLevel => ({ marginLeft: `${58 + nestingLevel * 13}px` });

class SidebarItems extends React.Component {

    render() {
        const { categoryItems } = this.props;
        const items = categoryItems.map((item, index) => {
            if (isPage(item)) {
                return <PageItem page={item} key={item.id + item.type} />;
            } if (isSuggestion(item)) {
                return <SuggestionItem suggestion={item} key={item.id + item.type} />;
            } if (isSubcategory(item)) {
                return <SubcategoryItem folder={item} key={item.id + item.type} />;
            } if (isExternal(item)) {
                return <ExternalResourceItem externalResource={item} key={item.id + item.type} />;
            } if (isQuestion(item)) {
                return <QuestionItem question={item} key={item.id + item.type} />;
            } if (isDocument(item)) {
                return <DocumentItem document={item} key={item.id + item.type} />;
            }
        });
        if (!items.length) {
            const page = { title: window.pageTitle };
            return <PageItem page={page} />;
        }

        return (
            <div>
                {items}
            </div>
        );
    }
}

export default SidebarItems;
